<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path
      d="M8.03 5.12C8.03 5.11 8.04 5.11 8.04 5.1C8.06 5.02 8.08 4.93 8.12 4.86C8.33 4.35 8.83 4 9.41 4C9.79 4 10.14 4.16 10.4 4.41L16 10V7.7H18V13.4H12.3V11.4H14.6L10 6.81V20H8V5.41C8 5.31 8.01 5.22 8.03 5.12Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
